export const CLOUD_PAYMENT_REQUIRED_EVENT = "venttify:cloud-payment-required";

export function isPaymentMethodRequiredError(code) {
  return code === "payment_method_required" || code === 131042;
}

export function openCloudPaymentRequiredDialog() {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new CustomEvent(CLOUD_PAYMENT_REQUIRED_EVENT));
}
